<script>
import { v4 as uuidv4 } from 'uuid';
import * as categoryService from '../../service/category.service';
import Multiselect from "vue-multiselect";

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: Array,
        required: true,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
        last_updated: {
            type: Object,
            required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Multiselect
    },
    data() {
        return {
            value: this.item_value || [],
            isModalVisible: false,
            new_item: '',
            options: [],
            d_check: this.selectedItem ? this.selectedItem[this.item.displayOn] : false
        };
    },    
    methods: {
        toggleModal() {
            this.isModalVisible = !this.isModalVisible;
        },
        addPPG() {
            this.value.unshift({
                id: uuidv4(),
                title: '',
                attachment: ''
            });
            // this.new_item = ''
        },
        removeItem(val) {
            this.value = this.value.filter(x => x.id != val.id)
        },
        async getOptions() {
            let filter = {
                "where": {
                "name": "Documents",
                "cmsId": this.$route.params.cmsId
                },
                "include": [
                {
                    "relation": "pages"
                }
                ]
            };

            filter = encodeURIComponent(JSON.stringify(filter));
            
            let data = await categoryService.getWithFilter(filter)
            let pages = data.length ? data[0].pages : [];
            this.options = pages
            
            // Use fileFormats prop if provided, otherwise default to PDF only
            let validFileFormats = this.item.fileFormats || ['application/pdf']
            
            // If fileFormats is set to 'all', don't filter by file format
            if (this.item.fileFormats === 'all') {
                this.options = pages
            } else {
                this.options = pages.filter(x => validFileFormats.includes(x.additionalProp1.fileFormat))
            }
            // this.value = this.options.filter(x => x.url == this.item_value)[0]
        }
    },
    computed: {
        display_none_check: {
            get: function () {
                return this.d_check;
            },
            set: function (newValue) {
                this.d_check = newValue;
            }
        }
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                    
                    this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                this.value = val || [];
            },
            deep: true
        },
        value(val) {
            this.updateValue(this.item_key, val);
        },
        display_none_check(val) {
            this.item.display = this.item.displayOn && !val ? false : true
        }    
    },
    async mounted() {
        await this.getOptions()
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <b-modal
            v-model="isModalVisible"
            style="letter-spacing: 2em;"
            id="add-ppg-newsletters"
            centered
            title="Add Item"
            title-class="font-18"
            hide-footer
        >
            <div class="d-flex mb-3">
            <input v-model="new_item" type="text" class="form-control mr-2" />  
            <button class="btn btn-primary" @click="addPPG(); $bvModal.hide('add-ppg-newsletters')">Add</button>
            </div>
        </b-modal>
        <div v-for="sg of value" :key="sg.id" class="d-flex">
            <input
                v-model="sg.title"
                type="text"
                class="form-control mb-2 mr-3"
            />
            <multiselect
                track-by="title"
                label="title"
                v-model="sg.attachment"
                :options="options"
                :searchable="options.length > 5 ? true : false"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="item.placeholder"
                :allow-empty="true"
                :preselectFirst="false"
            >
            <template slot="singleLabel" slot-scope="{option}">
                <span class="option__desc">
                    <span class="option__title">{{ option.title }}</span>
                </span>
            </template>
            <!-- <template slot="option" slot-scope="{option}">
                <img class="option__image" :src="option.url" alt="Image" style="height:5em">
                <div class="option__desc pt-3">
                    <span class="option__title">{{ option.title }}</span>
                </div>
            </template> -->
            </multiselect>
            <a class="font-size-14 mb-2 font-weight-medium ml-3 align-self-sm-center" role="button" style="color: #da3f3f"
            v-on:click="removeItem(sg)">Remove</a>  
        </div>
        <div class="mt-2">
            <a class="font-size-14 mb-2 ml-auto align-self-sm-center cursor-pointer"
            @click="addPPG()">+ Add Item</a> 
        </div>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>